import "./widget.scss";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import ChildCareRoundedIcon from "@mui/icons-material/ChildCareRounded";
import StyleRoundedIcon from "@mui/icons-material/StyleRounded";

const Widget = ({ data }) => {
  const renderIcon = () => {
    const iconSx = { fontSize: 36, color: "#261134" };
    if (data.table_name === "tbl_users") {
      return <PeopleAltRoundedIcon sx={iconSx} />;
    }
    if (data.table_name === "tbl_kid") {
      return <ChildCareRoundedIcon sx={iconSx} />;
    }
    if (data.table_name === "tbl_category") {
      return <StyleRoundedIcon sx={iconSx} />;
    }
    return null;
  };

  const label =
    data.table_name === "tbl_users"
      ? "Users"
      : data.table_name === "tbl_kid"
        ? "Kids"
        : data.table_name === "tbl_category"
          ? "Categories"
          : data.table_name.replace("tbl_", "");

  return (
    <div className="widget">
      <div className="left">
        <span className="widgetLabel">{label}</span>
        <span className="counter">
          <b>{data.count}</b>
        </span>
      </div>
      <div className="right">
        <div className="widgetIconBadge">{renderIcon()}</div>
      </div>
    </div>
  );
};

export default Widget;
